"use client";

import { Toaster as HotToaster } from "react-hot-toast";
import { Toast } from "./Toast";

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      gutter={8}
      containerStyle={{ bottom: 24, right: 24 }}
      toastOptions={{ duration: 4000 }}
    >
      {(t) => <Toast t={t} />}
    </HotToaster>
  );
}
